module.exports = __webpack_public_path__ + "img/Conversability_logo_200.b63a37d9.png";